jQuery(function($){
    const uploadArea = $('#upload-area');
    const fileInput = $('#upload-file');
    const errorMessage = $('.error-message');
    const maxFileSize = 10 * 1024 * 1024; 
    const allowedFileTypes = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
    let filesArray = []; 

    uploadArea.on('click', function(e) {
        if (e.target !== fileInput[0]) {
            fileInput.trigger('click');
        }
    }); 

    fileInput.on('change', function() {
        handleFiles(this.files);
    });

    // Drag and Drop events
    uploadArea.on('dragover', function(e) {
        e.preventDefault();
        uploadArea.addClass('dragging');
    });

    uploadArea.on('dragleave', function(e) {
        e.preventDefault();
        uploadArea.removeClass('dragging');
    });

    uploadArea.on('drop', function(e) {
        e.preventDefault();
        uploadArea.removeClass('dragging');
        const files = e.originalEvent.dataTransfer.files;
        handleFiles(files);
    });

    function handleFiles(files) {
        let valid = true;
        errorMessage.hide();

        $.each(files, function(index, file) {
            if (!allowedFileTypes.includes(file.type)) {
                valid = false;
                errorMessage.text('Ongeldig bestandstype: ' + file.name).show();
                return false; // break the loop
            }
            if (file.size > maxFileSize) {
                valid = false;
                errorMessage.text('Bestand is te groot: ' + file.name).show();
                return false; // break the loop
            }

            // If valid, add file to the filesArray and create the preview
            if (valid) {
                filesArray.push(file);
                createFilePreview(file);
            }
        });

        if (!valid) {
            fileInput.val(''); // Clear the input if invalid
        } else {
            updateFileInput();
        }
    }

    function createFilePreview(file) {
        const reader = new FileReader();
        reader.onload = function(e) {
            const filePreviewHTML = `
                <div class="file-preview d-f gap-10 fw-n b-white br-10 p-r f-a-c">
                    <img width="50" height="50" src="/wp-content/uploads/2024/10/Icons-5.svg" alt="${file.name}" class="file-preview-image br-16 flex-10">
                    <div class="file-preview-info flex-40 d-f fd-c">
                        <span class="file-preview-name">${file.name}</span>
                        <span class="file-preview-status w-500">Toegevoegd</span>
                    </div>
                    <span class="file-remove w-500" data-filename="${file.name}">Verwijder</span>
                </div>
            `;

            // Append the preview to the upload area
            uploadArea.after(filePreviewHTML);
        };

        reader.readAsDataURL(file);
    }

    // Event delegation for file-remove
    $(document).on('click', '.file-remove', function(e) {
        e.preventDefault();
        const fileName = $(this).data('filename');

        // Remove the file from the filesArray
        filesArray = filesArray.filter(file => file.name !== fileName);

        // Remove the preview element
        $(this).closest('.file-preview').remove();

        // Update the file input
        updateFileInput();
    });

    function updateFileInput() {
        const dataTransfer = new DataTransfer();
        filesArray.forEach(file => {
            dataTransfer.items.add(file);
        });
        fileInput[0].files = dataTransfer.files;
    }
});
